export default __webpack_public_path__ + "static/media/SörenLink.52499940.mp4";